import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { GROUPS, MODULES, canSee } from "@/lib/modules";
import { api } from "@/lib/api";

function useCriticalCount(enabled) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const load = () => api.get("/stock/critical/count").then(({ data }) => setN(data.count)).catch(() => {});
    load();
    window.addEventListener("stock:changed", load);
    return () => window.removeEventListener("stock:changed", load);
  }, [enabled]);
  return n;
}

const NavItem = ({ m, onNavigate, count }) => (
  <NavLink
    to={m.path}
    onClick={onNavigate}
    data-testid={`nav-${m.key}`}
    className={({ isActive }) =>
      `group flex items-center gap-2.5 px-2.5 py-[7px] rounded-md text-[13px] transition-colors ${
        isActive ? "bg-blue-600 text-white font-medium shadow-sm" : "text-slate-400 hover:text-white hover:bg-slate-800/80"
      }`
    }
  >
    <m.icon className="h-4 w-4 shrink-0" strokeWidth={1.8} />
    <span className="truncate flex-1">{m.label}</span>
    {count > 0 && (
      <span className="text-[10px] font-mono font-semibold px-1.5 py-0.5 rounded bg-rose-600 text-white" title="Kritik stok" data-testid={`nav-${m.key}-critical-badge`}>{count}</span>
    )}
    {!m.built && (
      <span className="text-[9px] font-mono px-1.5 py-0.5 rounded bg-slate-800 text-amber-400 border border-amber-500/20" data-testid={`nav-${m.key}-soon`}>
        Yakında
      </span>
    )}
  </NavLink>
);

export function SidebarNav({ onNavigate }) {
  const { can } = useAuth();
  const visible = MODULES.filter((m) => canSee(can, m));
  const critical = useCriticalCount(can("stok"));
  const [meta, setMeta] = useState({});
  useEffect(() => { fetch(`${process.env.REACT_APP_BACKEND_URL}/api/ping`).then((r) => r.json()).then(setMeta).catch(() => {}); }, []);
  return (
    <div className="flex flex-col w-full h-full">
      <div className="px-4 h-16 flex items-center gap-2.5 border-b border-slate-800">
        <div className="h-8 w-8 rounded bg-blue-600 grid place-items-center font-display font-extrabold text-white text-sm">İ</div>
        <div className="leading-tight">
          <div className="font-display font-extrabold text-white tracking-tight text-[15px]">İMAMOĞLU A.Ş</div>
          <div className="text-[10px] font-mono text-slate-500 uppercase tracking-widest" data-testid="sidebar-mode">ERP{meta.demo ? " · Preview" : ""}</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-4" data-testid="sidebar-nav">
        {GROUPS.map((g) => {
          const items = visible.filter((m) => m.group === g);
          if (!items.length) return null;
          return (
            <div key={g}>
              <div className="px-2.5 mb-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-600">{g}</div>
              <div className="space-y-0.5">{items.map((m) => <NavItem key={m.key} m={m} onNavigate={onNavigate} count={m.key === "stok" ? critical : 0} />)}</div>
            </div>
          );
        })}
      </nav>
      <div className="px-4 py-3 border-t border-slate-800 text-[10px] font-mono text-slate-600" data-testid="sidebar-version">{meta.version ? `v${meta.version} · ` : ""}TRY bazlı</div>
    </div>
  );
}
